import React, { ReactNode, useRef, useEffect } from 'react';
import { Rnd } from 'react-rnd';
import './Window.css';

interface WindowProps {
  id: string;
  title: string;
  children: ReactNode;
  position: { x: number; y: number };
  size: { width: number; height: number };
  minWidth?: number;
  minHeight?: number;
  onClose?: () => void;
  onFocus?: () => void;
  onPositionChange?: (position: { x: number; y: number }) => void;
  onSizeChange?: (size: { width: number; height: number }) => void;
  zIndex?: number;
  contentClassName?: string;
  closable?: boolean;
  lockAspectRatio?: boolean;
}

const Window: React.FC<WindowProps> = ({
  id,
  title,
  children,
  position,
  size,
  minWidth = 200,
  minHeight = 150,
  onClose,
  onFocus,
  onPositionChange,
  onSizeChange,
  zIndex = 1000,
  contentClassName,
  closable = true,
  lockAspectRatio = false
}) => {
  const rndRef = useRef<any>(null);
  
  return (
    <Rnd
      ref={rndRef}
      position={position}
      size={size}
      minWidth={minWidth}
      minHeight={minHeight}
      bounds="window"
      dragHandleClassName="window-header"
      enableResizing={true}
      style={{ zIndex }}
      lockAspectRatio={lockAspectRatio}
      className="game-window"
      onMouseDown={onFocus}
      onDragStop={(e, d) => {
        if (onPositionChange) {
          onPositionChange({ x: d.x, y: d.y });
        }
      }}
      onResizeStop={(e, direction, ref) => {
        if (onSizeChange) {
          onSizeChange({
            width: ref.offsetWidth,
            height: ref.offsetHeight
          });
        }
      }}
    >
      <div className="window-container">
        <div className="window-header">
          <span className="window-title">{title}</span>
          <div className="window-controls">
            {onClose && closable && (
              <button 
                className="window-control-btn close-btn"
                onClick={onClose}
                title="Закрыть"
              >
                ×
              </button>
            )}
          </div>
        </div>
        <div className={`window-content ${contentClassName || ''}`}>
          {children}
        </div>
      </div>
    </Rnd>
  );
};

export default Window;
